var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVulnerab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 5.0752L25.5561 22.8377H3.62488L14.4999 5.0752ZM14.4999 3.2627C13.9561 3.2627 13.2311 3.6252 13.0499 4.16895L1.99363 21.9314C1.26863 23.2002 2.17488 24.6502 3.44363 24.6502H25.3749C26.8249 24.6502 27.7311 23.0189 26.8249 21.9314L15.9499 4.16895C15.7686 3.6252 15.0436 3.2627 14.4999 3.2627Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.125C13.9562 18.125 13.5938 17.7625 13.5938 17.2188V11.7812C13.5938 11.2375 13.9562 10.875 14.5 10.875C15.0438 10.875 15.4062 11.2375 15.4062 11.7812V17.2188C15.4062 17.7625 15.0438 18.125 14.5 18.125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 20.4814C13.5938 20.7218 13.6892 20.9523 13.8592 21.1223C14.0291 21.2922 14.2596 21.3877 14.5 21.3877C14.7404 21.3877 14.9709 21.2922 15.1408 21.1223C15.3108 20.9523 15.4062 20.7218 15.4062 20.4814C15.4062 20.2411 15.3108 20.0106 15.1408 19.8406C14.9709 19.6707 14.7404 19.5752 14.5 19.5752C14.2596 19.5752 14.0291 19.6707 13.8592 19.8406C13.6892 20.0106 13.5938 20.2411 13.5938 20.4814Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVulnerab);
export default __webpack_public_path__ + "static/media/ic_vulnerab.f5c663e64f4b03b331276216d7fce7a4.svg";
export { ForwardRef as ReactComponent };